"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_react_modal_1 = __importDefault(require("styled-react-modal"));
const noop_1 = __importDefault(require("lodash/noop"));
const Tooltip_1 = __importDefault(require("../Tooltip"));
function TooltipWithModal(_a) {
    var { isOpen, onToggle, didAppear = noop_1.default, didDisappear = noop_1.default, backgroundChildren } = _a, props = __rest(_a, ["isOpen", "onToggle", "didAppear", "didDisappear", "backgroundChildren"]);
    const [opacity, setOpacity] = (0, react_1.useState)(0);
    const didAppearTimeoutId = (0, react_1.useRef)(0);
    const afterOpen = (0, react_1.useCallback)(() => {
        setTimeout(() => {
            setOpacity(1);
            didAppearTimeoutId.current = window.setTimeout(() => {
                clearTimeout(didAppearTimeoutId.current);
                didAppear();
            }, 400);
        }, 10);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const beforeClose = (0, react_1.useCallback)(() => {
        setOpacity(0);
        return new Promise(resolve => {
            setTimeout(() => {
                clearTimeout(didAppearTimeoutId.current);
                resolve();
                didDisappear();
            }, 400);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return ((0, jsx_runtime_1.jsx)(styled_react_modal_1.default, { isOpen: isOpen, onEscapeKeydown: onToggle, onBackgroundClick: onToggle, afterOpen: afterOpen, beforeClose: beforeClose, "data-e2e": 'TooltipWithModal_StyledModal', children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Tooltip_1.default, Object.assign({}, props, { opacity: opacity, "data-e2e": 'TooltipWithModal_Tooltip' })), backgroundChildren] }) }));
}
exports.default = TooltipWithModal;
